import { useQuery } from '@tanstack/react-query';
import { queryFetch } from '@services/api';
import { queryKeys } from '@utils/consts';
import { ApiError } from '@root/globalTypes';
import { useAppContext } from '@contexts/app';
import { usePanel } from '@hooks/usePanel';
import { useParams } from 'react-router';
import { EquipmentDropdownRespSuccess } from '@services/dropdowns/types';
import { useQueryParams } from '@hooks/queryParams';

export const usePanelEquipmentDropdown = () => {
  const {
    admin: { isLogged },
  } = useAppContext();
  const { tenantId } = useParams();
  const { parseParams } = useQueryParams();
  const { panel } = usePanel();

  const queryParams = parseParams({ tenantId });

  const { data, error, isPending } = useQuery<EquipmentDropdownRespSuccess, ApiError>({
    queryKey: [...queryKeys.dropdowns.panel.equipment, queryParams],
    queryFn: () => queryFetch({ url: `dropdowns/assets${queryParams}`, panel }),
    placeholderData: (previousData) => previousData as EquipmentDropdownRespSuccess,
    enabled: !!tenantId && isLogged && panel,
    retry: 2,
  });

  return {
    data,
    error,
    isLoading: isPending && !!tenantId && isLogged && panel,
  };
};
